import { render, staticRenderFns } from "./managementPack.vue?vue&type=template&id=8121436e&scoped=true"
import script from "./managementPack.vue?vue&type=script&lang=js"
export * from "./managementPack.vue?vue&type=script&lang=js"
import style0 from "./managementPack.vue?vue&type=style&index=0&id=8121436e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8121436e",
  null
  
)

export default component.exports